import * as Yup from 'yup';
import { takeLatest, call, put, select } from 'redux-saga/effects';

import {
  AUTH_ERRORS,
  SIGNUP_REQUEST,
  SUBMIT_COMPLETED,
} from 'data_system/token_auth/actionTypes';
import { getUserId, getResErrors } from 'data_system/token_auth/selectors';

export const createSagas = ({ Api }) => {
  function* signUpRequest({ params }) {
    const { email } = params;
    const validationSchema = Yup.object().shape({
      // eslint-disable-next-line object-curly-newline
      email: Yup.string().trim().email('Please enter a valid email address'),
    });
    try {
      yield call(validationSchema.validate, { email });
    } catch (err) {
      yield put({ type: AUTH_ERRORS, errors: err.errors });
    }

    const userId = yield select(getUserId);
    const uid = `${email}+${userId}`;

    try {
      yield call(Api.signUpRequest, { uid });
      yield put({ type: SUBMIT_COMPLETED });
    } catch (res) {
      yield put({ type: AUTH_ERRORS, errors: getResErrors(res) });
    }
  }

  return [takeLatest(SIGNUP_REQUEST, signUpRequest)];
};
